import {
  ShareAltOutlined,
  CopyOutlined,
  StopOutlined,
  DeleteOutlined,
  SendOutlined,
  EditOutlined
} from "@ant-design/icons"
import { MENU_ITEMS } from "constants/experiences"

export const getMenuConfig = (t, handlers) => ({
  [MENU_ITEMS.EDIT_CATEGORY]: {
    key: MENU_ITEMS.EDIT_CATEGORY,
    label: t("experiences.menu.edit_category"),
    icon: EditOutlined,
    onClick: handlers.onEditCategory
  },
  [MENU_ITEMS.SHARE]: {
    key: MENU_ITEMS.SHARE,
    label: t("global.share"),
    icon: ShareAltOutlined,
    onClick: handlers.onShare
  },
  [MENU_ITEMS.DUPLICATE]: {
    key: MENU_ITEMS.DUPLICATE,
    label: t("global.duplicate"),
    icon: CopyOutlined,
    onClick: handlers.onDuplicate
  },
  [MENU_ITEMS.DEACTIVATE]: {
    key: MENU_ITEMS.DEACTIVATE,
    label: t("global.deactivate"),
    icon: StopOutlined,
    onClick: handlers.onDeactivate
  },
  [MENU_ITEMS.DELETE]: {
    key: MENU_ITEMS.DELETE,
    label: t("global.delete"),
    icon: DeleteOutlined,
    onClick: handlers.onDelete,
    danger: true
  },
  [MENU_ITEMS.PUBLISH]: {
    key: MENU_ITEMS.PUBLISH,
    label: t("global.publish"),
    icon: SendOutlined,
    onClick: handlers.onPublish
  }
 
}) 